import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import i18n from './i18n'
import components from './components';
import 'normalize.css';
import './styles/index.scss';
import 'ant-design-vue/dist/antd.css';
import 'dayjs/locale/ar';
import 'dayjs/locale/zh-cn';
import 'dayjs/locale/en';
import '@wangeditor/editor/dist/css/style.css';
import { dayjsExtends } from '@/utils/plugins';
import dayjs from 'dayjs';
import { i18nAddResources } from '@wangeditor/editor';

i18nAddResources('ar', {
  // 表格模块
  tableModule: {
    deleteCol: "حذف عمود",           // 删除列
    deleteRow: "حذف صف",             // 删除行
    deleteTable: "حذف جدول",         // 删除表格
    widthAuto: "ضبط العرض تلقائيا",  // 宽度自适应
    insertCol: "ادراج عمود",         // 插入列
    insertRow: "ادراج صف",           // 插入行
    insertTable: "ادراج فيديو",      // 插入表格（表格原文如此）
    header: "رأس الجدول"             // 表头
  },
  // 视频模块
  videoModule: {
    delete: "حذف الفيديو",                              // 删除视频
    uploadVideo: "رفع فيديو",                          // 上传视频
    insertVideo: "ادراج صورة",                         // 插入视频（表格原文如此）
    videoSrc: "عنوان الفيديو",                         // 视频地址
    videoSrcPlaceHolder: "<iframe> عنوان URL لملف الفيديو أو جهة خارجية",
    videoPoster: "غلاف الفيديو",                       // 视频封面
    videoPosterPlaceHolder: "عنوان URL لصورة الغلاف",
    ok: "تأكيد",                                       // 确定
    editSize: "تعديل الحجم",
    width: "عرض",
    height: "عالي"
  },
  // 上传图片模块
  uploadImgModule: {
    uploadImage: "رفع صورة",                           // 上传图片
    uploadError: "{{fileName}} خطأ في التحميل"
  },
  // 列表模块
  listModule: {
    unOrderedList: "قائمة غير مرتبة",                  // 无序列表
    orderedList: "قائمة مرتبة او مرقمة"                // 有序列表
  },
  // 通用按钮
  common: {
    ok: "تأكيد",                                       // 确定
    delete: "حذف",                                     // 删除（表格未直接给出，使用标准译法）
    enter: "ادخال هو سطر جديد"                        // 回车
  },
  // 引用块
  blockQuote: {
    title: "اقتباس"                                    // 引用
  },
  // 代码块
  codeBlock: {
    title: "مربع ادراج الاكواد"                       // 代码块
  },
  // 颜色
  color: {
    color: "لون النص",                                 // 文字颜色
    bgColor: "لون الخلفية",                            // 背景色
    default: "اللون الافتراضى",                       // 默认颜色
    clear: "ازالة لون الخلفية"                        // 清除背景色
  },
  // 分割线
  divider: {
    title: "خط فاصل"                                   // 分割线
  },
  // 表情
  emotion: {
    title: "رمز تعبيرى او ايموجى"                     // 表情
  },
  // 字号
  fontSize: {
    title: "حجم الخط",                                 // 字号
    default: "حجم الخط الافتراضى"                     // 默认字号
  },
  // 字体
  fontFamily: {
    title: "نوع الخط",                                 // 字体
    default: "الخط الافتراضى"                         // 默认字体
  },
  // 全屏
  fullScreen: {
    title: "الشاشة كاملة"                              // 全屏
  },
  // 标题
  header: {
    title: "العنوان",                                  // 标题
    text: "النص الاصلى"                               // 正文
  },
  // 图片模块
  image: {
    netImage: "صورة من الانترنت",                     // 网络图片
    delete: "حذف",
    edit: "تحرير",
    viewLink: "عرض الرابط",
    src: "عنوان الرابط",                              // 链接地址
    desc: "وصف الصورة",
    link: "رابط الصورة"
  },
  // 缩进
  indent: {
    decrease: "تقليل المسافة البادئة",                // 减少缩进
    increase: "زيادة المسافة البادئة"                 // 增加缩进
  },
  // 对齐
  justify: {
    left: "محاذاة لليسار",                            // 左对齐
    right: "محاذاة لليمين",                           // 右对齐
    center: "توسيط",                                  // 居中对齐
    justify: "ضبط النص على الجانبين"                  // 两端对齐
  },
  // 行高
  lineHeight: {
    title: "تباعد او ارتفاع السطر",                   // 行高
    default: "تباعد السطر الافتراضى"                  // 默认行高
  },
  // 链接
  link: {
    insert: "ادراج رابط",                             // 插入链接
    text: "نص الرابط",                                // 链接文本
    url: "عنوان الرابط",                              // 链接地址
    unLink: "إلغاء الارتباط",
    edit: "تعديل الرابط",
    view: "عرض الرابط"
  },
  // 文字样式
  textStyle: {
    bold: "خط عريض او غامق",                          // 粗体
    clear: "مسح التنسيق",                             // 清除格式
    code: "كود مضمن داخل السطر",                      // 行内代码
    italic: "خط مائل",                                // 斜体
    sub: "العنوان السفلى",                            // 下标
    sup: "العنوان العلوى",                            // 上标
    through: "يتوسطه خط(شطب)",                        // 删除线
    underline: "التسطير"                              // 下划线
  },
  // 撤销/重做
  undo: {
    undo: "تراجع",                                    // 撤销
    redo: "اعادة"                                     // 重做
  },
  // 待办
  todo: {
    todo: "قائمة المهام"                              // 待办
  }
});

dayjs.extend(dayjsExtends);

createApp(App).use(store).use(router).use(components).use(i18n).mixin({
    methods: {
        /**
         * 截取图片
         */
        si(str) {
            return str?.split(',') ?? [];
        },
        /**
         * 取第一章图片
         */
        fi(str) {
            return this.si(str)[0];
        }
    }
}).mount('#app')
